import { FormFieldGroup, FormInput, FormLabel } from '$components'
import { Input } from './index'

export function EditBusinessDetailsContent() {
  return (
    <div className="flex flex-col gap-stack-section flex-grow">
      <FormFieldGroup>
        <FormLabel htmlFor={Input.BusinessName}>
          Business Name
        </FormLabel>

        <FormInput
          name={Input.BusinessName}
          placeholder="Enter your business name..."
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.ContactEmail}>
          Contact Email
        </FormLabel>

        <FormInput
          name={Input.ContactEmail}
          placeholder="Enter contact email..."
          type="email"
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.ContactPhone}>
          Contact Phone
        </FormLabel>

        <FormInput
          name={Input.ContactPhone}
          placeholder="Enter contact phone..."
          type="tel"
        />
      </FormFieldGroup>
    </div>
  )
}
